import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL ?? 'http://localhost:8080';

const api = axios.create({
  baseURL: API_BASE_URL,
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json'
  }
});

api.interceptors.request.use(
  config => {
    console.log('API请求:', config.method.toUpperCase(), config.url);
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  error => {
    console.error('API请求错误:', error);
    return Promise.reject(error);
  }
);

api.interceptors.response.use(
  response => {
    console.log('API响应:', response.config.method.toUpperCase(), response.config.url, response.status);
    // 检查是否有新的token
    const refreshedToken = response.headers['x-refreshed-token'];
    if (refreshedToken) {
      localStorage.setItem('token', refreshedToken);
      console.log('Token已刷新');
    }
    return response.data;
  },
  error => {
    console.error('API响应错误:', error.config?.method?.toUpperCase(), error.config?.url, error.response?.status, error.message);
    
    // 处理CORS错误
    if (error.message.includes('CORS')) {
      console.error('CORS错误:', error.message);
      return Promise.reject(new Error('网络连接失败，请检查网络设置后重试'));
    }
    
    if (error.response && error.response.status === 401) {
      console.log('Token过期，跳转到登录页面');
      localStorage.removeItem('token');
      window.location.href = '/login';
    }
    if (error.response?.data?.message && !error.message.includes(error.response.data.message)) {
      error.message = error.response.data.message;
    }
    return Promise.reject(error);
  }
);

export default api;

export const put = (url, data) => {
    return api({ method: 'put', url, data });
};